export type FeatureFlag = {
  id: string
  name: string
  description: string
  isEnabled: boolean
  scope: "global" | "tenant" | "user"
  updatedAt: string
  updatedBy: string
}

export const MOCK_FEATURE_FLAGS: FeatureFlag[] = [
  {
    id: "cadastre-esg-tab",
    name: "Cadastre ESG Tab",
    description:
      "Show the ESG tab on cadastre detail views with environmental data and energy ratings.",
    isEnabled: true,
    scope: "global",
    updatedAt: "2026-01-15T10:30:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "map-3d-view",
    name: "3D Map View",
    description: "Enable the 3D perspective view toggle on the map component.",
    isEnabled: false,
    scope: "tenant",
    updatedAt: "2026-01-10T14:20:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "advanced-export",
    name: "Advanced Data Export",
    description:
      "Allow users to export data in additional formats (GeoJSON, Shapefile, CSV with custom columns).",
    isEnabled: true,
    scope: "tenant",
    updatedAt: "2026-01-20T09:15:00Z",
    updatedBy: "lina@placepoint.no",
  },
  {
    id: "ai-property-valuation",
    name: "AI Property Valuation",
    description:
      "Enable AI-powered property valuation estimates based on historical data and market trends.",
    isEnabled: false,
    scope: "global",
    updatedAt: "2025-12-28T16:45:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "owner-history-tab",
    name: "Owner History Tab",
    description: "Show the ownership history tab on property detail views.",
    isEnabled: true,
    scope: "global",
    updatedAt: "2026-01-22T11:00:00Z",
    updatedBy: "lina@placepoint.no",
  },
  {
    id: "bulk-import",
    name: "Bulk Import",
    description: "Allow bulk import of properties and contacts via CSV upload.",
    isEnabled: false,
    scope: "tenant",
    updatedAt: "2026-01-05T08:30:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "custom-dashboards",
    name: "Custom Dashboards",
    description:
      "Allow users to create and save custom dashboard layouts with configurable widgets.",
    isEnabled: false,
    scope: "user",
    updatedAt: "2026-01-18T13:00:00Z",
    updatedBy: "lina@placepoint.no",
  },
  {
    id: "commercial-lease-module",
    name: "Commercial Lease Module",
    description:
      "Enable the commercial lease management module for tracking lease agreements and rent rolls.",
    isEnabled: true,
    scope: "tenant",
    updatedAt: "2026-01-25T15:30:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "api-v2-endpoints",
    name: "API v2 Endpoints",
    description:
      "Enable access to the new v2 REST API endpoints for external integrations.",
    isEnabled: false,
    scope: "tenant",
    updatedAt: "2026-01-12T10:00:00Z",
    updatedBy: "admin@placepoint.no",
  },
  {
    id: "dark-mode",
    name: "Dark Mode",
    description: "Enable dark mode theme toggle in user preferences.",
    isEnabled: true,
    scope: "user",
    updatedAt: "2026-01-20T17:00:00Z",
    updatedBy: "lina@placepoint.no",
  },
]
